// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3FiQy","title":"Header_title__1STyW","left":"Header_left__23ZN1","clinicName":"Header_clinicName__1mmw6"};